import { render } from "./Fullorder.vue?vue&type=template&id=f2eda536&ts=true"
import script from "./Fullorder.vue?vue&type=script&lang=ts"
export * from "./Fullorder.vue?vue&type=script&lang=ts"

import "./Fullorder.vue?vue&type=style&index=0&id=f2eda536&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__